module.exports = function (options) {
  var classname = options["class"] != undefined ? options["class"] : '';
  return "<li id=\"".concat(options.id, "\" class=\"game-menu-icon ").concat(classname, "\">").concat(options.text, "</li>");
};